export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/grid-14c3727c50f70502285f23909754ae0e.jpg";